import { VisitEncounterMode } from '@dreryk/egabinet-visit-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Dropdown, IconFillColor, IconWrapper, StyledFlex, VideoConsultationIcon } from '@dreryk/react-components';

import { VideoConsultationPatientContactUpdateShowModalEventInterceptor } from '~libs.desktop.video-consultation';

import { visitTranslationKeys } from '../../../translations';

const t = visitTranslationKeys.controlsBar.visitEncounterMode;

type VideoConsultationDropdownItemProps = {
   onClick: (visitEncounterMode: Extract<VisitEncounterMode, 'VIDEO_CONSULTATION'>) => Promise<void>;
   patientId: number;
};

export const VideoConsultationDropdownItem = (props: VideoConsultationDropdownItemProps): JSX.Element => {
   const hide = Dropdown.useHide();

   return (
      <VideoConsultationPatientContactUpdateShowModalEventInterceptor
         onClose={hide}
         patientId={props.patientId}
         shouldShowModal
      >
         <Dropdown.Item
            testId={'videoConsultation'}
            onClick={async (hide) => props.onClick('VIDEO_CONSULTATION').finally(hide)}
         >
            <StyledFlex alignItems={'center'} gap={4}>
               <IconWrapper testId={'videoConsultation'} fillColor={IconFillColor.BACKGROUND}>
                  <VideoConsultationIcon />
               </IconWrapper>
               <Translate>{t.VIDEO_CONSULTATION}</Translate>
            </StyledFlex>
         </Dropdown.Item>
      </VideoConsultationPatientContactUpdateShowModalEventInterceptor>
   );
};
